var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"loading":_vm.isLoading,"type":"primary"},on:{"click":_vm.submitBtn}},[_vm._v(_vm._s(_vm.isLoading?(_vm.btnName+'中...'):_vm.btnName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }